// extracted by mini-css-extract-plugin
export default {"seriesButton":"SeriesButton_seriesButton__WOjom"};